import { createFileRoute, Outlet } from "@tanstack/react-router";

// Layout route: /journal/* children (article pages) render through here.
// The Journal list itself lives at ./journal/index.tsx ("/_public/journal/").
export const Route = createFileRoute("/_public/journal")({
  component: () => <Outlet />,
});
